// import logo from './logo.svg';
import '@fontsource/inter';
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import LoaderSpin from "./cmp/LoaderSpin";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import MainLogin from "./cmp/MainLogin";
import PersistentDrawerLeft from "./cmp/PersistentDrawerLeft";
import SubLocationMaster from "./cmp/Master/SubLocationMaster";
import Protected from "./cmp/Protected";
import Dashboard from "./cmp/Dashboard";
import CompanyMaster from "./cmp/Master/CompanyMaster";
import PlantMaster from "./cmp/Master/PlantMaster";
import LocationMaster from "./cmp/Master/LocationMaster";
import DepartmentMaster from "./cmp/Master/DepartmentMaster";
import CategoryMaster from "./cmp/Master/CategoryMaster";
import AssetMaster from "./cmp/Master/AssetMaster";
import CustomerMaster from "./cmp/Master/CustomerMaster";
import EmployeeMaster from "./cmp/Master/EmployeeMaster";
import EmailMaster from "./cmp/Master/EmailMaster";
import DashboardLayout from "./cmp/DashboardLayout";
import PrintAssetBarcode from "./cmp/Transaction/PrintAssetBarcode";
import ReprintAssetBarcode from "./cmp/Transaction/ReprintAssetBarcode";
import GenratedBarPrint from "./cmp/Transaction/GenratedBarPrint";
import ReportGenBarcode from "./cmp/Report/ReportGenBarcode";
import ReportAssetIdentification from "./cmp/Report/ReportAssetIdentification";
import ReportAvailableAsset from "./cmp/Report/ReportAvailableAsset";
import ReportAssetAssign from "./cmp/Report/ReportAssetAssign";
import ReportAssetDeAssign from "./cmp/Report/ReportAssetDeAssign";
import ReportAssetIssued from "./cmp/Report/ReportAssetIssued";
import ReportAssetPendingFRec from "./cmp/Report/ReportAssetPendingFRec";
import ReportAssetReceipt from "./cmp/Report/ReportAssetReceipt";
import ReportAssetInTransitDiversion from "./cmp/Report/ReportAssetInTransitDiversion";
import ReportAssetDepreciation from './cmp/Report/ReportAssetDepreciation';
import RepAssetPhStockTake from './cmp/Report/RepAssetPhStockTake';
import ReportAssetOverAllRep from './cmp/Report/ReportAssetOverAllRep';
import ReportCostDep from './cmp/Report/ReportCostDep';
import UserRoleMaster from './cmp/Administrator/UserRoleMaster';
import UserMaster from './cmp/Administrator/UserMaster';
import DashboardHome from './cmp/Dashboard/DashboardHome';
import ChangePassword from './cmp/Administrator/ChangePassword';
import AndroidAppAccess from './cmp/Administrator/AndroidAppAccess';
import BuildingVisualization from './cmp/3D/BuildingVisualization';

function App() {
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(
      function (config) {
        setLoader(true);
        return config;
      },
      function (error) {
        setLoader(false); // Ensure loader is stopped on error
        return Promise.reject(error);
      }
    );

    const responseInterceptor = axios.interceptors.response.use(
      function (response) {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        return response;
      },
      function (error) {
        setLoader(false); // Ensure loader is stopped on error
        return Promise.reject(error);
      }
    );

    return () => {
      // Eject the interceptors on cleanup to avoid memory leaks
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);
  return (
    <div className="App">
      {/* <LoaderSpin show={loader} /> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLogin />} />
          <Route path="/3D" element={<BuildingVisualization />} />
          {/* <Route path="Dashboard" element={<PersistentDrawerLeft />} /> */}

          <Route path="test" element={<DashboardLayout />} />
          <Route
            path="/dashboard/*"
            element={
              <Protected>
                <Dashboard/>
              </Protected>
            }
          >
            {/* ==================Company Master Router======================= */}
            <Route path="CompanyMaster" element={<CompanyMaster />} />
            <Route path="PlantMaster" element={<PlantMaster />} />
            <Route path="LocationMaster" element={<LocationMaster />} />
            <Route path="SubLocationMaster" element={<SubLocationMaster />} />
            <Route path="DepartmentMaster" element={<DepartmentMaster />} />
            <Route path="CategoryMaster" element={<CategoryMaster />} />
            <Route path="AssetMaster" element={<AssetMaster />} />
            <Route path="CustomerMaster" element={<CustomerMaster />} />
            <Route path="EmployeeMaster" element={<EmployeeMaster />} />
            <Route path="EmailMaster" element={<EmailMaster />} />
            {/* ==================Company Transaction Router======================= */}
            <Route path="PrintAssetBarcode" element={<PrintAssetBarcode/>}/>
            <Route path="ReprintAssetBarcode" element={<ReprintAssetBarcode/>}/>
            <Route path="GenrateBarcodeAsset" element={<GenratedBarPrint/>}/>
            {/* ==================Report Router======================= */}
            <Route path="ReportAssetGenerateBarcode" element={<ReportGenBarcode/>}/>
            <Route path="ReportAssetIdentification" element={<ReportAssetIdentification/>}/>
            <Route path="ReportAvailableAsset" element={<ReportAvailableAsset/>}/>
            <Route path="ReportAssetAssign" element={<ReportAssetAssign/>}/>
            <Route path="ReportAssetDeAssign" element={<ReportAssetDeAssign/>}/>
            <Route path="ReportAssetIssued" element={<ReportAssetIssued/>}/>
            <Route path="ReportAssetPendingFRec" element={<ReportAssetPendingFRec/>}/>
            <Route path="ReportAssetReceipt" element={<ReportAssetReceipt/>}/>
            <Route path="ReportAssetInTransitDiversion" element={<ReportAssetInTransitDiversion/>}/>
            <Route path='ReportAssetDepreciation' element={<ReportAssetDepreciation/>}/>
            <Route path='RepAssetPhStockTake' element={<RepAssetPhStockTake/>}/>
            <Route path='ReportAssetOverAllReport' element={<ReportAssetOverAllRep/>}/>
            <Route path='ReportCostDepreciation' element={<ReportCostDep/>}/>
            {/* ====================== Administrator =============================== */}
            <Route path='UserRoleMaster' element={<UserRoleMaster/>}/>
            <Route path='UserMaster' element={<UserMaster/>}/>
            <Route path='UserChangePassword' element={<ChangePassword/>}/>
            <Route path='androidappaccess' element={<AndroidAppAccess/>}/>
            {/* ====================== Dashboard =============================== */}
            <Route path='dashbordhome' element={<DashboardHome/>}/>
 
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

export default App;
